<template>
<div>
    <vs-card style="padding: 0 !important; margin: 0 !important;">
        <vs-row style="background: linear-gradient(118deg, rgba(var(--vs-primary),1), rgba(var(--vs-primary),0.7));
              padding: 10px 12px !important;
              margin: 0 important;
              display: flex;
              align-items: center; ">
            <vs-col class="w-1/2">
                <h4 style="margin-left:14%;color:white ; padding: 0;">Prescription</h4>
            </vs-col>
            <vs-col class="w-1/2">
            <div style="margin-left:90%;cursor:pointer;">
                
                    <feather-icon icon="XIcon" @click="exit()" style="color:white" class="custom-class"></feather-icon>
                
            </div>
            </vs-col>
        </vs-row>
        <vs-divider style="margin-top:0;"></vs-divider>

        <div style="padding-left:5%;padding-right:5%;padding-bottom:10%;">

            <!-- error message -->
            <vs-row style="margin-bottom:20px">
                <vs-alert color="danger" icon-pack="feather" icon="icon-info" v-for="error in errors.all()" v-bind:key="error">
                    <span>{{error}}</span>
                </vs-alert>
            </vs-row>
<vs-row class="mb-6" style="align-items: stretch;">
  <!-- Left column with border -->
  <vs-col class="w-2/5">
    <div class="info-section">
      <vs-row>
        <vs-col class="w-1/2">
          <p class="value-large"><b>OP No :</b> &nbsp;{{prescriptionDetail.refId}}</p>
          <p class="value-large"><b>Patient ID :</b>&nbsp; {{patientId}}</p>
          <p class="value-large"><b>Name :</b> &nbsp;{{patientDetail.name}}</p>
          <p class="value-large"><b>Age :</b> &nbsp;{{patientDetail.age}} &nbsp;&nbsp; 
            <b>Sex :</b> {{patientDetail.gender}}</p>
        </vs-col>

        <vs-col class="w-1/2">
          <p class="value-large"><b>Date:</b> &nbsp;{{formatDate(prescriptionDetail.prescriptionDate)}}</p>
          <p class="value-large"><b>Doctor Name:</b>&nbsp; {{prescriptionDetail.doctorName}}</p>
          <p class="value-large"><b>Ref Type:</b>&nbsp; OP</p>
          <p class="value-large"><b>Type No:</b> &nbsp;{{prescriptionDetail.refTypeId}}</p>
        </vs-col>
      </vs-row>
    </div>
  </vs-col>

  <!-- Right column without outer border -->
 <vs-col class="w-3/5 right-column">
  <div style="display:flex; align-items:center;">
    <label class="label-large">Patient Problem</label>
    <vs-textarea
      v-model="prescriptionDetail.patientProblem"
    
      class="w-full"
      name="patientProblem"
      placeholder="Enter patient problem"
      style="resize:none;min-height:80px;"
    />
  </div>

  <div style="display:flex; align-items:center;">
    <label class="label-large">Doctor Notes</label>
    <vs-textarea
      v-model="prescriptionDetail.doctorOverview"
      class="w-full"
      placeholder="Enter doctor notes"
      style="resize:none;min-height:80px;"
    />
  </div>
</vs-col>

</vs-row>

          <vs-row>
  <vs-col vs-lg="12" vs-sm="12">
     <h4 style="margin-bottom:10px;margin-top:20px; ">Medicines</h4>
    <table style="width:100%;">
      <thead>
        <tr style="border:1px solid #e4dada">
          <th style="width:3%; text-align:center">SrNo</th>
       <th style="width:22%; text-align:center">Medicine Name</th>
<th style="width:5%; text-align:center">Unit</th>
<th style="width:5%; text-align:center">Morning</th>
<th style="width:5%; text-align:center">Afternoon</th>
<th style="width:5%; text-align:center">Evening</th>
<th style="width:5%; text-align:center">No Of Days</th>
<th style="width:3%; text-align:center"></th>

        </tr>
      </thead>

      <tbody>
        <tr hoverFlat v-for="(value, index) in medicineData" :key="index">
          <td>
            <vs-input style="border:none" class="w-full configclass" type="text" readonly v-model="value.srNo"/>
          </td>

          <td>
           
 <multiselect
  v-model="value.medicineName"
  :options="medicineOptions.map(m => m.medicineName)"
  :searchable="true"
  :loading="isLoadingMedicines"
  placeholder="Type or add medicine"
  @search-change="fetchMedicines"
  :taggable="true"
  @tag="(newTag) => addCustomMedicine(newTag, value)"
   @input="medicineNameChanged(index)" 
  class="multiselect--prescription"
/>

          </td>

         <td>
 <multiselect
    v-model="value.unit"
    :options="unitOptions"
    :searchable="true"
    :allow-empty="true"
    :taggable="true"
    placeholder="Select unit"
    @tag="(newTag) => addCustomUnit(newTag, value)"
  
    
  />
</td>
<td>
  <vs-input class="w-full configclass" type="text" v-model="value.morning"   @input="formatFoodTiming(value, 'morning')"/>
</td>
<td>
  <vs-input class="w-full configclass" type="text" v-model="value.afternoon"  @input="formatFoodTiming(value, 'afternoon')" />
</td>
<td>
  <vs-input class="w-full configclass" type="text" v-model="value.evening"   @input="formatFoodTiming(value, 'evening')"/>
</td>


          <td>
            <vs-input class="w-full configclass" type="text" v-model="value.noOfDays"/>
          </td>
            <td style="text-align:center;">
              <feather-icon icon="Trash2Icon" class="mr-0 cursor-pointer"  style="color: #ff0000;" @click="deleteRow(index)"></feather-icon>
            </td>
        </tr>
      </tbody>
    </table>
  </vs-col>
</vs-row>

             
 <vs-row class="mb-6">
   <vs-col class="w-8/12">
    <div >

      <h4 style="margin-bottom:10px;margin-top:20px; ">Lab Tests</h4>
    <div  class="labtest-table">
      <table style="width:80%;">
        <thead>
          <tr  style="border:1px solid #e4dada">
            <th style="width:3%; text-align:center">Sr No.</th>
            <th style="width:22%; text-align:center">Test Name</th>
            <th style="width:3%; text-align:center"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(test, index) in labTests" :key="index">
            <td>
              <vs-input type="text" v-model="test.srNo" readonly class="w-full"/>
            </td>
            <td>
                          <multiselect
                  v-model="test.testName"
                  :options="testOptions"
                  :loading="isLoadingTests"
                  :allow-empty="true"
                  :taggable="true"
                  placeholder="Select or add test"
                  @tag="(newTag) => addCustomTest(newTag, test)"
                    @input="testNameChanged(index)" 
                  class="multiselect--prescription"
                />

            </td>
            
            <td style="text-align:center;">
              <feather-icon icon="Trash2Icon" class="mr-0 cursor-pointer"  style="color: #ff0000;" @click="deleteTest(index)"></feather-icon>
            </td>
           
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </vs-col>
 <vs-col class="w-4/12">
    <!-- Empty space to align with remaining Medicine table columns -->
  </vs-col>
</vs-row>
<printPrescription
v-show="showPris"
  
  
  :prescriptionDetail="prescriptionDetail"
  :patientDetail="patientDetail"
  :medicineData="medicineData"
  :labTests="labTests"
  :patientId="patientId"
  style="display:none"
/>

 </div>
        <!-- footer -->
    </vs-card>
    <vs-row>
        <vs-card class="footer">
            <div class="btn-group"   style="
          display: flex;
          justify-content: flex-end;
          gap: 5px;
           margin-right: 180px; 
           
          flex-wrap: wrap;
        ">
               
                <vs-button color="success" @click="savePrescription" type="filled" :disabled="saveFlag" style="min-width:110px;">Save</vs-button>
                   
               <vs-button @click="print" type="gradient" style="min-width:110px;">Print</vs-button>
                <vs-button     @click="exit()" color="danger" type="filled" style="min-width:110px;">Exit</vs-button>
            </div>
        </vs-card>

        <!-- ------- -->
    </vs-row>
</div>
  
</template>

<script>
import Multiselect from 'vue-multiselect';
//import 'vue-multiselect/dist/vue-multiselect.min.css';
import printPrescription from "@/components/printPrescription.vue";
export default {
components: { Multiselect,printPrescription},
    data() {
        return {
            patientId: "",
            showPris:false,
            patientDetail: {},
            prescriptionDetail: {
                patientProblem: "",
                doctorOverview: "",
                doctorId: "",
                doctorName: "",
                refId: "",
                refTypeId: 1,
                prescriptionDate: new Date().toISOString().slice(0, 10),
            },
            medicineData:[{
            srNo: '1',
            medicineName: "",
            unit: "",
            morning: "",
            afternoon: "",
            evening: "",
            noOfDays: ""
        }],
   medicineOptions: [],
    isLoadingMedicines: false,
    medicineSearchTimeout: null,
             labTests: [
      { srNo: "1", testName: "" }
    ],
    unitOptions: [
      "1/2",
      "1",
      "2",
      "3",
      "1/2 ml",
      "1 ml",
      "2 ml",
      "3 ml",
      "4 ml",
      "5 ml",
      "6 ml",
      "7 ml",
      "8 ml",
      "9 ml",
      "10 ml",
    ],
    testOptions: [],
  isLoadingTests: false,
  saveFlag: false,

    }
    },
    
       beforeMount() {
  if (this.$route.query.patientId && this.$route.query.opId) {

    this.patientId = this.$route.query.patientId;
 this.prescriptionDetail.refId= this.$route.query.opId;
    this.prescriptionDetail.refTypeId = this.$route.query.refType;

    // Always load patient & OP details
    this.getpatientDetails();
    this.getopdetails();
this.getTestEntryList();

    // New part
    const status = this.$route.query.status;
    const prescriptionId = this.$route.query.prescriptionId;

    if (status === 'Y' && prescriptionId) {
      // Existing prescription — fetch details
      this.getPrescriptionDetails(prescriptionId);
    } else {
      console.log("Creating new prescription entry for this OP");
    }

  } else {
    this.$router.push({ path: '*' });
  }


    },
    methods: {
    getTestEntryList() {
  this.isLoadingTests = true;
  this.$http.post(
    "getTestEntryList",
    JSON.stringify({}),
    { headers: { "Content-Type": "application/json" } }
  )
  .then(response => {
    if (response.data.statusCode === 200 && Array.isArray(response.data.data)) {
      this.testOptions = response.data.data.map(t => t.testName);
    } else {
      this.testOptions = [];
    }
  })
  .catch(error => {
    console.error("Error fetching test list:", error);
    this.testOptions = [];
  })
  .finally(() => {
    this.isLoadingTests = false;
  });
},
exit(){
   const from = this.$route.query.from;

  if (from === "patientTray") {
    this.$router.push({
      path: "/patientTray",
      query: { patientId: this.$route.query.patientId }
    });
  } else if (from === "opdashboard") {
    this.$router.push({ path: "/OpDashboardView" });
  } else {
    this.$router.go(-1);
  }

},
 
addCustomTest(newTag, currentRow) {
  if (!this.testOptions.includes(newTag)) {
    this.testOptions.push(newTag);
  }
  
  currentRow.testName = newTag;

  const index = this.labTests.indexOf(currentRow);
  if (index === this.labTests.length - 1) {
    this.labTests.push({
      srNo: this.labTests.length + 1,
      testName: ""
    });
  }
},
  testNameChanged(index) {
const currentRow = this.labTests[index];
    
    if (index === this.labTests.length - 1 && currentRow.testName) {
        this.labTests.push({
         srNo: this.labTests.length + 1,
          testName: ""
        });
    }
  },

       fetchMedicines(query) {
    if (!query) {
      this.medicineOptions = [];
      return;
    }

    // Prevent too many calls — debounce
    clearTimeout(this.medicineSearchTimeout);
    this.medicineSearchTimeout = setTimeout(() => {
      this.isLoadingMedicines = true;

      const request = { name: query };

      this.$http
        .post("searchMedicineList", JSON.stringify(request), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (response.data.statusCode === 200 && Array.isArray(response.data.data)) {
            // Map results directly from backend
            this.medicineOptions = response.data.data;
          } else {
            this.medicineOptions = [];
          }
        })
        .catch((error) => {
          console.error("Error fetching medicines:", error);
          this.medicineOptions = [];
        })
        .finally(() => {
          this.isLoadingMedicines = false;
        });
    }, 400); // Wait 400ms after typing
  },
addCustomMedicine(newMedicine, currentRow) {
  // Check if the medicine already exists in list
  if (!this.medicineOptions.some(m => m.medicineName === newMedicine)) {
    this.medicineOptions.push({ medicineName: newMedicine });
  }

  // Immediately assign this typed name to the current row
  currentRow.medicineName = newMedicine;

  const index = this.medicineData.indexOf(currentRow);
  if (index === this.medicineData.length - 1) {
    this.medicineData.push({
      srNo: this.medicineData.length + 1,
      medicineName: "",
      unit: "",
      morning: "",
      afternoon: "",
      evening: "",
      noOfDays: ""
    });
  }
},
addCustomUnit(newUnit, currentRow) {
  
    if (!this.unitOptions.includes(newUnit)) {
      this.unitOptions.push(newUnit);
    }

   
    currentRow.unit = newUnit;
},
        getpatientDetails() {
            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };
            this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    this.patientDetail = response.data.data;

                });
        },
        getopdetails() {
            var request = {
                companyId: this.$session.get('companyId'),
                refId: this.prescriptionDetail.refId,
                billType: 1,
                attachedFlag: "Y"
            };
            this.$http.post(
                    "v2/getopdetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    this.prescriptionDetail.doctorId = response.data.data.opData.doctorId;
                    this.prescriptionDetail.doctorName = response.data.data.opData.doctorName;
                });
        },

       savePrescription() {
         if (this.isSaving) return; 
  this.saveFlag = true;
  
  const cleanedMedicineData = this.medicineData.filter(
    m => m.medicineName && m.medicineName.trim() !== ""
  );

  const cleanedLabTests = this.labTests.filter(
    t => t.testName && t.testName.trim() !== ""
  );

  // Build request body
  const request = {
    companyId: this.$session.get('companyId'),
    userId: this.$session.get('userId'),
    refId: this.prescriptionDetail.refId,
    refType: this.prescriptionDetail.refTypeId,
    prescriptionDate: this.prescriptionDetail.prescriptionDate,
    patientProblem: this.prescriptionDetail.patientProblem || "", // optional
    prescriptionId: this.$route.query.prescriptionId || "",       // optional
    doctorOverview: this.prescriptionDetail.doctorOverview || "", // optional
    medicineDetails:cleanedMedicineData,
    labTests: cleanedLabTests,             // can be empty
    patientId: this.patientId,
      doctorId: this.prescriptionDetail.doctorId,
  };

  // Send API request
  this.$http.post(
    "savePrescription",
    JSON.stringify(request),
    { headers: { "Content-Type": "application/json" } }
  )
  .then(response => {
    if (response.data.statusCode == 200) {
      this.prescriptonId = response.data.data.prescriptonId;
      this.$vs.notify({
        title: "Saved Successfully",
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      });
    } else {
      this.$vs.notify({
        title: "Unable to Save",
        text: response.data.message || "Please try again.",
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "top-center"
      });
    }
  })
  .catch(() => {
    this.$vs.notify({
      title: "Error Occurred While Saving",
      text: "Please try later",
      color: "danger",
      iconPack: "feather",
      icon: "icon-x",
      position: "top-center"
    });
  })
    .finally(() => {
    this.saveFlag = false; 
  });
},

         deleteRow(deleteRowIndex) {
            if (deleteRowIndex > 0) {
                this.$delete(this.medicineData, deleteRowIndex);
            }

        },
          deleteTest(index) {
    if (this.labTests.length > 1) {
      this.labTests.splice(index, 1);
      // Update SrNo after delete
      this.labTests.forEach((t, i) => t.srNo = i + 1);
    }
  },

   
     
        medicineNameChanged(index) {
          console.log("new row add called")
    const currentRow = this.medicineData[index];
    // Only add new row if it's the last row and medicineName is not empty
    if (index === this.medicineData.length - 1 && currentRow.medicineName) {
        this.medicineData.push({
            srNo: this.medicineData.length + 1,
            medicineName: "",
            unit: "",
            morning: "",
            afternoon: "",
            evening: "",
            noOfDays: ""
        });
    }
},
formatFoodTiming(row, field) {
  let val = row[field];
  if (!val) return;

  
  val = val.trim();


  const lower = val.toLowerCase();


  if (lower === "bf") {
    row[field] = "Before Food";
    return;
  }

 
  if (lower === "af") {
    row[field] = "After Food";
    return;
  }

  
  if (/^\d+\s*bf$/i.test(val)) {
    const num = val.match(/\d+/)[0];
    row[field] = `${num} Before Food`;
    return;
  }

  if (/^\d+\s*af$/i.test(val)) {
    const num = val.match(/\d+/)[0];
    row[field] = `${num} After Food`;
    return;
  }
},

  formatDate(date) {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  },
       print() {
        this.showPris = true
  this.$nextTick(() => {
    setTimeout(() => {
      window.print()
      this.showPris = false
    }, 300) // increase to 500 if image is big
  })
        },
       getPrescriptionDetails(prescriptionId) {
  this.prescriptonId = prescriptionId; // assign to local variable for reuse

  var request = {
    companyId: this.$session.get('companyId'),
    prescriptionId: prescriptionId,
    patientId: this.patientId
  };

  this.$http.post(
    "getPrescriptionDetails",
    JSON.stringify(request),
    { headers: { "Content-Type": "application/json" } }
  )
  .then(response => {
    if (response.data.statusCode == 200 ) {
      const data = response.data.data;
console.log("prescription data",data)
      
      this.prescriptionDetail.prescriptionDate = data.prescriptionDate;
      this.prescriptionDetail.patientProblem = data.patientProblem;
      this.prescriptionDetail.doctorOverview = data.doctorOverview;
  

    
       this.medicineData = data.medicineDetails && data.medicineDetails.length
        ? data.medicineDetails
        : [];
 if (
        this.medicineData.length === 0 ||
        this.medicineData[this.medicineData.length - 1].medicineName
      ) {
        this.medicineData.push({
          srNo: (this.medicineData.length + 1).toString(),
          medicineName: "",
          unit: "",
          morning: "",
          afternoon: "",
          evening: "",
          noOfDays: ""
        });
      }
            this.labTests = data.labTests && data.labTests.length
        ? data.labTests
        : [];
         if (
        this.labTests.length === 0 ||
        this.labTests[this.labTests.length - 1].testName
      ) {
        this.labTests.push({
          srNo: (this.labTests.length + 1).toString(),
          testName: ""
        });
      }
    }
  })
  .catch(error => {
    console.error("Error loading prescription details:", error);
  });
}

    }
}



     

</script>

<style scoped>

.info-section {
  border: 2px solid #ddd;
  border-radius: 12px;
 padding:  12px; /* increased top/bottom padding from 10px → 15px */
  background-color: #eaeff3
  ;    
  height: 95%;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Centers the content vertically */
 
}

.value-large {
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
  margin: 8px 5px;
 
}
/* Add to your existing style */
.right-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* This makes top and bottom sections stretch */
  height: 100%;
  margin-top: 10px;
}
.vs-textarea {
  flex: 1; /* grow to fill available height */
   margin: 0;
}

.label-large {
  font-weight: bold;
  font-size: 12px;
  width: 25%;
  white-space: nowrap;
  margin-right: 10px;
  display: flex;
  align-items: center; /* vertically center labels */
  
}

.vs-textarea textarea {
  margin: 0; /* remove internal margin */
  padding: 8px;
  height: 100%; /* fill the flex container */
  box-sizing: border-box;
}


.footer {
    position: fixed;
    left: 0;
    bottom: -20px;
    width: 100%;
    z-index: 500;

}
table thead {
    background: #eaeff3;
}


.vs-col {
  padding-bottom: 0 !important;
}
</style>
